import { render } from "./menutop.vue?vue&type=template&id=1017004d&scoped=true"
import script from "./menutop.vue?vue&type=script&lang=js"
export * from "./menutop.vue?vue&type=script&lang=js"

import "./menutop.vue?vue&type=style&index=0&id=1017004d&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1017004d"]])

export default __exports__